import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const BazaarVoiceReviewsSummary = ({ productReviewsSummaryContainer, className, reviewsHeading }) =>
  <div data-at-bv-review-summary className={ className }>
    { reviewsHeading && <ReviewsHeading data-at-heading-subheading="reviews">Reviews</ReviewsHeading> }
    <div id={ productReviewsSummaryContainer } />
  </div>

BazaarVoiceReviewsSummary.propTypes = {
  className: PropTypes.string,
  productReviewsSummaryContainer: PropTypes.string,
  reviewsHeading: PropTypes.bool
}

const ReviewsHeading = styled.h2`
  margin: 0;
  font-weight: bold;
  padding: 0 0 20px;
`

export default BazaarVoiceReviewsSummary
